import { initCenterPositionFromCenter } from '@/commons/fabricjs/FabricPositionHelper';
import { FONT_SIZE_MULTIPLIER } from '@/guidetti/projectConstantes';
import { FabricText, StaticCanvas } from 'fabric';

function applyTextDefaultConfig(fText: FabricText /* , alignCenter = true */) {
    fText.set({
        lockScalingFlip: true, // disable scaling flip by applying a minimum size
        textAlign: 'center',
        fontFamily: 'Arial',
        fill: '#000000',
        fontSize: 30,
        fontWeight: 'normal', // 'bold'
        fontStyle: 'normal', // 'italic'
        underline: false,
        cornerColor: '#6441DA',
        borderColor: '#6441DA',
        name: 'textId',
    });
    fText.setControlsVisibility({
        // m stand for middle, then t is top, b is bottom, l is left, r is right
        mt: false,
        mb: false,
        ml: false,
        mr: false,
        mtr: true, // rotation handle
    });
    // if (alignCenter) {
    //     centerPosition(fText);
    // }
}

function updateText(fabricCanvas: StaticCanvas | null, fText: FabricText | null, text: string, alignCenter = true): FabricText | null {
    if (!fabricCanvas || !fText) {
        return null;
    }
    const centerPosition = initCenterPositionFromCenter(fabricCanvas, fText);
    fText.set('text', text);
    if (alignCenter) {
        centerPosition(fText);
    }
    fabricCanvas?.renderAll();
    return fText;
}

function updateFontFamily(fabricCanvas: StaticCanvas | null, fText: FabricText | null, fontFamily: string, alignCenter = true) {
    if (!fabricCanvas || !fText) {
        return;
    }
    const centerPosition = initCenterPositionFromCenter(fabricCanvas, fText);
    fText.set('fontFamily', fontFamily);
    fText.setCoords();
    fText.set('dirty', true);
    if (alignCenter) {
        centerPosition(fText);
    }
    fabricCanvas?.renderAll();
}

function updateFontSize(
    fabricCanvas: StaticCanvas | null,
    fText: FabricText | null,
    fontSize: number,
    alignCenter = true,
): FabricText | null {
    if (!fabricCanvas || !fText) {
        return null;
    }
    const centerPosition = initCenterPositionFromCenter(fabricCanvas, fText);
    fText.set('fontSize', fontSize * FONT_SIZE_MULTIPLIER);
    if (alignCenter) {
        centerPosition(fText);
    }
    fText.setCoords();
    fText.set('dirty', true);
    fabricCanvas?.renderAll();
    return fText;
}

/**
 * Update color of font
 * @param fontColor hexa color string
 */
function updateFontColor(fabricCanvas: StaticCanvas | null, fText: FabricText | null, fontColor: string) {
    if (!fabricCanvas || !fText) {
        return;
    }

    fText.set('fill', fontColor);
    fabricCanvas?.renderAll();
}

function updateFontWeight(fabricCanvas: StaticCanvas | null, fText: FabricText | null, fontWeight: string = 'normal', alignCenter = true) {
    if (!fabricCanvas || !fText) {
        return;
    }
    const centerPosition = initCenterPositionFromCenter(fabricCanvas, fText);
    fText.set('fontWeight', fontWeight); // can be 'normal' or 'bold'
    if (alignCenter) {
        centerPosition(fText);
    }
    fabricCanvas?.renderAll();
}

function updateFontStyle(
    fabricCanvas: StaticCanvas | null,
    fText: FabricText | null,
    fontStyle: string = 'normal',
    alignCenter = true,
): FabricText | null {
    if (!fabricCanvas || !fText) {
        return null;
    }
    const centerPosition = initCenterPositionFromCenter(fabricCanvas, fText);

    fText.set('fontStyle', fontStyle); // can be 'normal' or 'italic'
    if (alignCenter) {
        centerPosition(fText);
    }
    fabricCanvas?.renderAll();
    return fText;
}

function updateUnderline(fabricCanvas: StaticCanvas | null, fText: FabricText | null, underline: boolean /* , alignCenter = true */) {
    if (!fabricCanvas || !fText) {
        return;
    }
    fText.set('underline', underline);
    fabricCanvas?.renderAll();
}

function updateAngle(fabricCanvas: StaticCanvas | null, fText: FabricText | null, angle: number) {
    if (!fabricCanvas || !fText) {
        return;
    }
    fText.rotate(angle);
    fText.setCoords();
    fabricCanvas?.renderAll();
}

function textScaleToFontsize(fText: FabricText | null) {
    if (!fText) return;
    const { scaleX, scaleY, fontSize, left, top } = fText;
    const newFontSize = Math.round(fontSize * Math.min(scaleX, scaleY));
    fText.set('fontSize', newFontSize);
    fText.set('scaleX', 1);
    fText.set('scaleY', 1);
    fText.set('left', left);
    fText.set('top', top);
    fText.setCoords();
    fText.set('dirty', true);
}

export {
    applyTextDefaultConfig,
    textScaleToFontsize,
    updateAngle,
    updateFontColor,
    updateFontFamily,
    updateFontSize,
    updateFontStyle,
    updateFontWeight,
    updateText,
    updateUnderline,
};
